/* Copyright 2013 - 2024 Waiterio LLC */
export default typeof process !== 'undefined' && process.env.JEST_WORKER_ID
